var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AppIcon",class:{
    isSquare: _vm.isSquare,
    isEmpty: !_vm.src,
  },style:(_vm.computedStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }